module.exports = __webpack_public_path__ + "img/ATRC Platform - Website TCs-06.2bb0ae6e.png";